import { render } from "./MapChart.vue?vue&type=template&id=1ca38253"
import script from "./MapChart.vue?vue&type=script&lang=js"
export * from "./MapChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__